import React, { useContext, useMemo } from 'react';
import './styles/Contact.css';
import test2 from './../assets/contactBG.webp';
import ContactForm from '../components/ContactForm';
import config from '../config/config';
import SEO from '../seo/SEO';
import generateBreadcrumbs from '../utility/generateBreadcrumbs';
import { ContactContext } from '../context/ContactContext';

const Contact = () => {
    const { contacts, loading, formatPhone } = useContext(ContactContext);

      // ✅ Dynamically build structured data for contacts
    const contactPoints = useMemo(() => {
        if (!contacts || contacts.length === 0) return [];

        return contacts
            // ✅ Only filter out if visible is explicitly false
            .filter((c) => c.visible !== 0 && c.visible !== false)
            .map((c) => {
            const contact = {
                "@type": "ContactPoint",
                "contactType": c.name.includes("Larry")
                ? "Customer Support"
                : "Sales & Inquiries",
                "areaServed": "US",
                "availableLanguage": ["English"],
            };

            if (c.show_phone !== 0 && c.phone_raw) {
                contact.telephone = c.phone_raw;
            }

            if (c.show_email !== 0 && c.email) {
                contact.email = c.email;
            }

            return contact;
            })
            // ✅ Finally, drop any contact points that have neither phone nor email
            .filter((c) => c.telephone || c.email);
    }, [contacts]);



      // ✅ Build JSON-LD only when data exists
        const jsonLd = useMemo(() => {
            if (!contactPoints || contactPoints.length === 0) return null;
            return {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Withrow Knives",
            "url": `${config.metadata.siteUrl}/contact`,
            "description":
                "Reach out to Withrow Knives for general inquiries, custom knife orders, or customer support.",
            "breadcrumb": generateBreadcrumbs(["contact"]),
            "contactPoint": contactPoints,
            "address": {
                "@type": "PostalAddress",
                "addressRegion": "West Virginia",
                "addressCountry": "US",
            },
            };
        }, [contactPoints]);



    return (
        <>
            <SEO
            title="Contact Withrow Knives - Reach Out for Inquiries & Custom Orders"
            description="Have a question? Contact Withrow Knives for inquiries, custom orders, or general support via phone, email, or our contact form."
            keywords={[
                "contact Withrow Knives",
                "custom knives inquiry",
                "knife shop contact",
                "handmade knives support",
                "knife orders",
                "customer support",
            ]}
            url={`${config.metadata.siteUrl}/contact`}
            jsonLd={{
                "@context": "https://schema.org",
                "@type": "ContactPage",
                "name": "Contact Withrow Knives",
                "url": `${config.metadata.siteUrl}/contact`,
                "description":
                "Reach out to Withrow Knives for general inquiries, custom knife orders, or customer support.",
                "breadcrumb": generateBreadcrumbs(["contact"]),
                "contactPoint": contactPoints, // stays empty until loaded
                "address": {
                "@type": "PostalAddress",
                "addressRegion": "West Virginia",
                "addressCountry": "US",
                },
            }}
            />

            <div className='page-wrapper'>
                <div 
                    className='page-title' 
                    style={{ backgroundImage: `url(${test2})`, backgroundSize: "cover", backgroundPosition: "50% 70%" }}
                >
                    <h1>CONTACT US</h1>
                </div>

                <section className='page-content-section'>
                    <div className="contact-container">
                        <div className="contact-info">
                            <div className="contact-details">
                                <h2>Get in Touch</h2>
                                <p>
                                Need to get in touch, or have a question about our knives,
                                custom orders, or services? We’d love to hear from you.
                                </p>

                                {contacts.length > 0 && (
                                <ul>
                                    {contacts.map((c) => (
                                    <li key={c.id} className="contact-item">
                                        <h3>{c.name}</h3>

                                        {c.phone_display && (
                                        <p>
                                            <strong>Phone:</strong>{" "}
                                            <a href={`tel:${c.phone_raw}`}>
                                            {formatPhone(c.phone_display)}
                                            </a>
                                        </p>
                                        )}

                                        {c.email && (
                                        <p>
                                            <strong>Email:</strong>{" "}
                                            <a href={`mailto:${c.email}`}>{c.email}</a>
                                        </p>
                                        )}
                                    </li>
                                    ))}

                                    <li>
                                    <strong>Contact Hours:</strong> Monday - Friday: 9 AM - 5 PM EST
                                    </li>
                                    <li>
                                    <strong>Location:</strong> <i>West Virginia</i>
                                    </li>
                                </ul>
                                )}
                            </div>
                            <div className="mapContainer">
                                <iframe
                                    title="West Virginia Google Maps"
                                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3808985.513846705!2d-81.53526767221462!3d38.82031962759739!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884a54a5d4cb0945%3A0xbb00c768decd3a43!2sWest%20Virginia!5e1!3m2!1sen!2sus!4v1741503591211!5m2!1sen!2sus"
                                    width="100%"
                                    height="100%"
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    style={{ border: 0 }}
                                ></iframe>
                            </div>
                        </div>

                        <ContactForm />
                    </div>
                </section>
            </div>
        </>
    );
};

export default Contact;
